import { Element } from '../../../../html/element'
import { GroupCriteria } from '../GroupCriteria'
import classes from './index.module.scss'

export const LayoutContent = ({ data, onClickDelete }) => {
  return (
    <Element
      style={{ borderColor: '#D5D5D5' }}
      className={classes.layoutContent}
    >
      <GroupCriteria data={data} onClickDelete={onClickDelete} />
    </Element>
  )
}
